import { getClientId, getVisaHost } from "@linkfluence/konf";
import { Product } from "@linkfluence/models/product";
import { cleanTokens } from "@linkfluence/visa/tokens";
export { isAuthenticated, cleanTokens } from "@linkfluence/visa/tokens";

const _getUrl = (host: string, endpoint: string) => {
  return host + endpoint;
};

const getVisaUrl = (url: string) => _getUrl(getVisaHost(), url);

export function redirectToLogin(client: Product, redirectPath: string = "/") {
  const origin = window.location.origin + window.location.pathname;
  const redirectUrl = `${origin}?redirect=${encodeURIComponent(redirectPath)}`; // Front's URL + requested page
  const loginUrl = getVisaUrl(
    `/sso/pre-login` +
      `?clientId=${getClientId(client)}` +
      `&redirect=${encodeURIComponent(redirectUrl)}`
  );
  window.location.replace(loginUrl);
}

export function redirectToLogout() {
  const origin = window.location.origin;
  const logoutUrl = getVisaUrl(
    `/logout?redirect=${encodeURIComponent(origin)}`
  );

  cleanTokens();
  window.location.replace(logoutUrl);
}

export function redirectToInitialPage(redirectPath: string = "/") {
  const initiallyRequestedPageURL =
    window.location.origin + window.location.pathname + "#" + redirectPath;
  window.location.replace(initiallyRequestedPageURL);
}
